import { FlexContainer } from 'features/common/components/FlexContainer';
import { Text } from 'features/common/components/Text';
import { Icon as UnstyledIcon } from 'features/common/components/Icon';
import styled from 'styled-components';

export const CardContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	border-radius: 12px;
	background-color: ${({ theme }) => theme.colors.whitePearl};
	border: 1px solid ${({ theme }) => theme.colors.punchupOrange};

	padding: 20px 24px;

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		padding: 16px 18px;
		gap: 16px;
	}
`;

export const Header = styled(FlexContainer)`
	padding-bottom: 12px;
	border-bottom: 1px solid ${({ theme }) => `${theme.colors.punchupOrange}33`};
`;

export const FieldsGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: 14px;
`;

export const WrapperInputs = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 12px;

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		grid-template-columns: 1fr;
	}
`;

export const Divider = styled.div`
	height: 1px;
	width: 100%;
	background-color: ${({ theme }) => `${theme.colors.punchupOrange}22`};
`;

export const RecipientName = styled(Text)`
	font-weight: 600;
	font-size: 16px;
	line-height: 1.2;
	margin: 0;
	color: ${({ theme }) => theme.colors.black};
`;

export const Icon = styled(UnstyledIcon)`
	cursor: pointer;
	color: ${({ theme }) => theme.colors.punchupOrange};
	transition: opacity 0.2s ease-in-out;

	&:hover {
		opacity: 0.7;
	}
`;
